export default __webpack_public_path__ + "static/media/image-1.a1960167.webp";